import React from 'react';
import styled from 'styled-components';
import { isFunction } from 'lodash';

import { Dialog } from '../Dialog/Dialog';
import Button from '../Button/Button';

import { ConfirmActionManager } from '.';

const ConfirmMessageWrap = styled.div`
  width: 100%;
  padding: 10px 0;
  text-align: center;
  line-height: 25px;
  white-space: pre-line;
`;

function ConfirmComponent(props) {
  const { message, close, maxWidth } = props;

  const onOk = () => {
    if (isFunction(ConfirmActionManager.ok)) ConfirmActionManager.ok();
    close();
  };

  const onCancel = () => {
    if (isFunction(ConfirmActionManager.cancel)) ConfirmActionManager.cancel();
    close();
  };

  const actions = [
    <Button key="cancel" onClick={onCancel}>
      Cancel
    </Button>,
    <Button key="ok" color="primary" onClick={onOk}>
      Confirm
    </Button>,
  ];

  return (
    <Dialog open={!!message} actions={actions} fullWidth maxWidth={maxWidth || 'xs'}>
      <ConfirmMessageWrap>{message}</ConfirmMessageWrap>
    </Dialog>
  );
}

export default ConfirmComponent;
